import { WorkoutAchievementType } from "../../../../../common/enums";
import { WorkoutAchievementTypeLabels } from "../../../../../common/labels";
import { IWorkoutSetAchievement } from "../../../../../common/components/workoutPlanDialog/models/workoutPlanViewModel";

const formatKg = (kg: number): string =>
  `${Number.isInteger(kg) ? kg : Math.round(kg * 100) / 100} кг`;

const formatVolumeKg = (kg: number): string =>
  `${Math.round(kg).toLocaleString("bg-BG")} кг`;

/** "120 кг" for a weight record, "1 200 кг" for a set-volume record. */
export const formatAchievementValue = (
  type: WorkoutAchievementType,
  value: number,
): string =>
  type === WorkoutAchievementType.MaxWeight
    ? formatKg(value)
    : formatVolumeKg(value);

/** "100 кг × 12" — the set behind a record. */
export const formatSetLine = (kg: number, reps: number): string =>
  `${formatKg(kg)} × ${reps}`;

const FIRST_RECORD_LABEL = "Първи рекорд";

/**
 * "+20 кг" — how much the previous best was beaten by. A first record (the first completed
 * set on the exercise) beat nothing, so it reads "Първи рекорд" instead.
 */
export const formatImprovement = (
  type: WorkoutAchievementType,
  value: number,
  previousValue: number | null,
): string =>
  previousValue === null
    ? FIRST_RECORD_LABEL
    : `+${formatAchievementValue(type, value - previousValue)}`;

/** One-line celebration message for the toast shown when a set earns badges. */
export const formatAchievementToast = (
  exerciseName: string,
  achievements: IWorkoutSetAchievement[],
): string => {
  const parts = achievements.map(
    (a) =>
      `${WorkoutAchievementTypeLabels[a.type]}: ${formatAchievementValue(a.type, a.value)}`,
  );
  return `Нов рекорд · ${exerciseName} — ${parts.join(" · ")}`;
};
